import { getLocale } from "../runtime";

const da_returntohomepage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tilbage til forsiden`
};

const en_returntohomepage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Return to Homepage`
};

const es_returntohomepage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Volver a la página principal`
};

const fi_returntohomepage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Palaa etusivulle`
};

const nb_returntohomepage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tilbake til forsiden`
};

const sv_returntohomepage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tillbaka till startsidan`
};

const returntohomepage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_returntohomepage(inputs)
	if (locale === "en") return en_returntohomepage(inputs)
	if (locale === "es") return es_returntohomepage(inputs)
	if (locale === "fi") return fi_returntohomepage(inputs)
	if (locale === "nb") return nb_returntohomepage(inputs)
	if (locale === "sv") return sv_returntohomepage(inputs)
	return "returnToHomepage";
};

export { returntohomepage as "returnToHomepage" };